import styled, { css } from 'styled-components';
import { Card } from '../main/CommonStyles';

const getStatusStyles = (status, theme) => {
    switch (status) {
        case 'NOWE':
            return css`
                background-color: ${theme.colors.primaryLightest};
                border-left-color: ${theme.colors.primary};
                .status-badge { background-color: ${theme.colors.primary}; }
            `;
        case 'W_TRAKCIE':
            return css`
                background-color: #fffbe6; // Jasny żółty
                border-left-color: #f59e0b; // Ciemniejszy żółty
                .status-badge { background-color: #f59e0b; }
            `;
        case 'ROZWIAZANE':
            return css`
                background-color: ${theme.colors.secondaryLight + '40'};
                border-left-color: ${theme.colors.secondary};
                .status-badge { background-color: ${theme.colors.secondary}; }
            `;
        default: // ZAMKNIETE
            return css`
                background-color: ${theme.colors.neutralLight};
                border-left-color: ${theme.colors.textDisabled};
                opacity: 0.8;
                .status-badge { background-color: ${theme.colors.textDisabled}; }
            `;
    }
};

export const ReportList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const ReportCard = styled(Card)`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
    border-left: 6px solid;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    ${({ status, theme }) => getStatusStyles(status, theme)};

    &:hover {
        transform: translateY(-3px);
        box-shadow: ${({ theme }) => theme.shadows.lg};
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
    }

    h3 {
        font-size: 1.2rem;
        color: ${({ theme }) => theme.colors.textDark};
        margin: 0;
        flex-grow: 1;
    }
    
    .status-badge {
        font-size: 0.75rem;
        font-weight: 700;
        padding: 0.25rem 0.75rem;
        border-radius: 50px;
        color: white;
        text-transform: uppercase;
    }

    .card-footer {
        font-size: 0.8rem;
        color: ${({ theme }) => theme.colors.textMedium};
    }
`;